import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkerboard from './Checkerboard.svg';
import "./ColorPicker.css"
import ColorPickerPalette from './ColorPickerPallete';
import PickerOutput from './helpers/PickerOutput';
import PickerInput from './helpers/PickerInput';

class ColorPicker extends Component {
    constructor(props) {
        super(props);
        const rgba = PickerInput(this.props.color);
        this.state = { 
            color: rgba.rgb,
            alpha: rgba.alpha,
            isPaletteOpen: false,
            colorTable: []   
        }
        this.buttonRef = React.createRef();
    }

    static propTypes = {
        color: PropTypes.string.isRequired,
        containerRef: PropTypes.shape({current: PropTypes.instanceOf(Element)}),
        onChange: PropTypes.func.isRequired
    }
    

    toggleOpenPalette = () => {
        this.setState((prevState) => ({ isPaletteOpen: !prevState.isPaletteOpen }));
    }
    closePalette = () => {
        this.setState({ isPaletteOpen: false });
    }

    /**
     * @param {React.MouseEvent} e
     */
    updateColor = ( rgbHex, alpha) => {
        this.setState({ color: rgbHex, alpha });
        document.getElementById('colorInput').value=rgbHex;
        this.updateAlpha(rgbHex, alpha); 
    }

    updateAlpha = (rgbHex, alpha) => {
        this.setState({ color: rgbHex, alpha: alpha });
        document.getElementById('alphaInput').value=(Math.round(alpha * 100) + '%');
    }

    updateColorFromInput = (hexInput) => {
        if (this.checkIfHex(hexInput.target.value) === true) {
            this.updateColor(hexInput.target.value, this.state.alpha); 
            this.props.onChange(PickerOutput(hexInput.target.value, this.state.alpha));
            this.closePalette();
        }
        else {
            document.getElementById('colorInput').value="";
        }
    }

    onConfirm = (color = this.state.color, alpha = this.state.alpha) => {
        if (typeof this.props.onChange === "function") {
            this.props.onChange(PickerOutput(color, alpha));
        }
    }

    onCancel = () => {
        const inputColor = document.getElementById('colorInput');
        const inputColorValue = inputColor.value;
        if (this.checkIfHex(inputColorValue)) {
            if(inputColorValue !== this.props.color) {
                    this.updateColor(inputColorValue, this.state.alpha); 
                    this.props.onChange(PickerOutput(inputColorValue, this.state.alpha));
            } else {
                this.setColorFromProps();  
            }
        } else {
            this.setColorFromProps();
        }
        this.closePalette();
    }

    defaultColors = () => {

        if (this.state.colorTable.length <= 23) {
            this.setState((prevState) => {
                return {colorTable: [...prevState.colorTable, ...this.props.variables]};
            });
        }
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.color !== this.props.color) {
            this.setColorFromProps();
        }
    }

    componentDidMount = () => {
        this.defaultColors();
    }

    setColorFromProps = () => { 
        const rgba = PickerInput(this.props.color);
        this.setState({color: rgba.rgb, alpha: rgba.alpha});
    }

    checkIfHex = (hex) => {
        let isHex = false;
        const hexRegex = /[0-9a-fA-F]+/;
        if(hex[0] === '#' && hex.length === 7) {
            for(let i=1;i<hex.length;i++) { 
                if(hex[i].match(hexRegex) === null) {
                    isHex = false;
                    return isHex;
                }
            }
            isHex = true;
        }
        return isHex;
    }

    render = () => {
        let btnClassName = 'color-picker-btn';
        if (this.state.isPaletteOpen) {
            btnClassName += ' color-picker-btn--active';
        }
        
        return (
            <div className="color-picker">
                <div
                    ref={this.buttonRef}
                    aria-expanded={this.state.isPaletteOpen}
                    aria-label="Open color picker"
                    className={btnClassName}
                    style={{ 
                        background: "left top/contain white",
                        backgroundImage: `linear-gradient(to right, ${PickerOutput(this.state.color,this.state.alpha) }, ${PickerOutput(this.state.color,this.state.alpha) }), url(${Checkerboard})`,
                        }}
                    onClick={this.toggleOpenPalette}
                />
                
                {this.state.isPaletteOpen &&
                    <ColorPickerPalette
                        color={this.state.color}
                        alpha={this.state.alpha}
                        buttonRef={this.buttonRef}
                        containerRef={this.props.containerRef}
                        colors={this.colorTable}
                        onChange={this.updateColor}
                        onConfirm={this.onConfirm}
                        onCancel={this.onCancel}
                        onBlur={this.updateColorFromInput}
                        toggleRef={this.closePalette}
                    />
                }
            </div>
        );
    }
}

export default ColorPicker